import httpService from "./httpService";

export default {
  getAll: async () => httpService.get(`/documentType?IncludeFullDetails=false`),
  get: async id => httpService.get(`/documentType/${id}`),

  getFromTemplate: documentTypeTemplateId =>
    httpService.get(`/documentType/template/${documentTypeTemplateId}/instance`),
};
